<template>
    <div class="flex justify-center mb-4">
        <button
            :class="[
                selectionsVisible
                    ? 'bg-racing-stars-yellow text-gray-900'
                    : 'bg-[#272727] text-white',
            ]"
            class="rounded-l-md py-2 px-4 text-xs sm:text-base"
            @click="showSelections()"
        >
            Selections
        </button>
        <button
            :class="[
                leaderboardVisible
                    ? 'bg-racing-stars-yellow text-gray-900'
                    : 'bg-[#272727] text-white',
            ]"
            class="rounded-r-md py-2 px-4 text-xs sm:text-base"
            @click="showLeaderboard()"
        >
        Leaderboard
        </button>
    </div>

    <div v-if="selectionsVisible">
        <div
            class="flex text-red-900 bg-red-300 p-4 rounded justify-center items-center mb-4 mt-4 sm:mt-0 text-xs sm:text-base"
            v-if="error.message"
        >
            <span class="flex grow">{{ error.message }}</span>

            <a
                class="rounded py-2 px-4 bg-racing-stars-yellow text-gray-900 shadow-md"
                :href="route('store')"
                v-if="error.cta"
                >Purchase Tokens</a
            >
        </div>

        <div
            class="p-4 text-center rounded bg-racing-stars-yellow text-gray-900 mb-4 mt-4 sm:mt-0"
            v-if="message"
        >
            {{ message }}
        </div>

        <div
            class="flex gap-2 mb-2"
            v-if="meeting.finished_at == null && !hasBet"
        >
            <div class="flex-1">
                <button
                    type="button"
                    class="inline-flex border-gray-600 border-1 items-center justify-center px-4 py-2 text-xs sm:text-base font-medium rounded-md text-white bg-[#272727] focus:outline-none w-full h-full shadow-md"
                    @click="clearSelections()"
                >
                    Clear Selections
                    <XIcon class="ml-3 -mr-1 h-5 w-5" aria-hidden="true" />
                </button>
            </div>
            <div class="flex-1">
                <button
                    type="button"
                    :class="{ 'cursor-not-allowed opacity-50': processing }"
                    class="inline-flex items-center justify-center px-4 py-2 text-xs sm:text-base font-medium rounded-md text-gray-900 border-black border-2 bg-racing-stars-yellow focus:outline-none w-full shadow-md"
                    @click="confirmSelections()"
                    :disabled="processing"
                >
                        Confirm Selections
                    <CheckIcon class="ml-3 -mr-1 h-5 w-5" aria-hidden="true" />
                </button>
            </div>
        </div>
        <!-- <div v-for="selection in sortedArray"> -->
    <div v-for="selection in sortedArray">
            <div
                class="mr-1 relative w-fill rounded-lg flex cursor-pointer text-white h-20 mb-2"
                :class="[
                    selection.boost_applied_to == selection.id
                        ? 'bg-gradient-to-r from-purple-500 to-purple-700'
                        : '',
                    selection.jockey?.team 
                        ? 'bg-rl-' + selection.jockey?.team
                        : 'bg-[#272727]'
                ]"

            >
                <selection
                    :selection="selection"
                    :results="results"
                    :user="user"
                    :team="selection.jockey?.team"
                    @changeSelection="changeSelection"
                />
            </div>
        </div>
    </div>

    <div v-if="leaderboardVisible">
        <leaderboard :user="$page.props.user" :leaderboard="leaderboard" />
    </div>

    <div class="flex justify-center mt-8 mb-4">
        <!--        <button :class="[selectionsVisible ? 'bg-racing-stars-yellow text-gray-900' : 'bg-gray-700 text-white']" class="rounded-l-md py-2 px-4" @click="showSelections()">Selections</button>-->
        <!--        <button :class="[leaderboardVisible ? 'bg-racing-stars-yellow text-gray-900' : 'bg-gray-700 text-white']" class="rounded-r-md py-2 px-4" @click="showLeaderboard()">Leaderboard</button>-->
    </div>

    <tw-modal
        :show="showPlaceBetModal"
        padding="true"
        width="500"
        @close="showPlaceBetModal = false"
        style="background-color: #030712;"
    >
        <h2
            class="mt-2 mb-6 text-3xl font-semibold dark:text-racing-stars-yellow text-center"
        >
            {{ meeting.name }}
        </h2>
        <span class="my-2 text-center text-lg">
            <p>{{ meeting.meeting_start }}</p>
        </span>

        <div
            v-if="error.message"
            class="text-center font-semibold text-red-400"
        >
            {{ error.message }}
        </div>

            <div
                class="p-2 rounded-lg mt-2"
                v-if="!error.message && $page.props.features.boosters"
            >
                <p
                    v-if="this.selectedBooster.booster == 0 && $page.props.settings.site_name == 'Racing Stars'"
                    class="font-semibold mb-2"
                >
                    Choose your Booster:
                </p>
                <p
                    v-else-if="this.selectedBooster.booster == 0 && $page.props.settings.site_name == 'Racing League'"
                    class="font-semibold mb-2"
                >
                    Apply a Joker:
                </p>
                <p v-else class="font-semibold mb-2">
                    Your Booster of Choice :
                </p>

                <div v-for="selection in sortedArray" class="flex">
                    <div
                        v-if="
                            this.selectedBooster.booster == 0 ||
                            this.selectedBooster.runner == selection.id
                        "
                        class="relative w-full rounded-lg border-gray-400 border-2 flex cursor-pointer text-white mb-2"
                        :class=" selection.jockey?.team 
                        ? 'bg-rl-' + selection.jockey?.team
                        : 'bg-[#272727]'"
                    >
                        <booster-selection
                            v-if="
                                this.selectedBooster.booster == 0 ||
                                this.selectedBooster.runner == selection.id
                            "
                            :selection="selection"
                            :results="results"
                            :selectedBooster="selectedBooster"
                            @changeBooster="changeBooster"
                        />
                    </div>

                    <button
                        @click="clearBooster()"
                        v-if="
                            !this.selectedBooster.booster == 0 &&
                            this.selectedBooster.runner == selection.id
                        "
                        class="mb-2 ml-1 rounded-lg border-2 border-red-400 bg-gray-800 w-16 h-16 p-2 text-red-400 hover:bg-gray-700 active:bg-gray-600 font-semibold flex-shrink-0"
                    >
                        <XCircleIcon class="text-red-400" />
                    </button>
                </div>
            </div>

            <div class="flex items-center justify-center mt-4">
                <tw-button
                    :secondary="true"
                    :sm="true"
                    @click="(showPlaceBetModal = false)"
                    class="mr-4"
                    >Cancel</tw-button
                >
                <tw-button
                    class="disabled:opacity-50 disabled:cursor-not-allowed"
                    :disabled="
                        processing
                    "
                    @click="placeBet()"
                    >Continue</tw-button
                >
            </div>
    </tw-modal>
</template>

<script>
import { ref, onMounted, computed, toRaw } from "vue";
import {
    XIcon,
    CheckIcon,
    DatabaseIcon,
    LightningBoltIcon,
    XCircleIcon,
} from "@heroicons/vue/outline";
import Selection from "@/Global/Play/Partials/Selection";
import BoosterSelection from "@/Global/Play/Partials/BoosterSelection";
import { useStore } from "vuex";
import Leaderboard from "@/Global/Play/Partials/Leaderboard";
import TwModal from "@/Global/Elements/TwModal";
import Popper from "vue3-popper";

export default {
    props: {
        user: {
            type: Object,
            default: {},
        },
        meeting: {
            type: Object,
            default: {},
        },
        selections: {
            type: Object,
            default: {},
        },
        bets: {
            type: Array,
            default: [],
        },
    },

    emits: ["changeSelection", "betPlaced", "hasBet"],

    computed: {
        sortedArray: function () {
            function compare(a, b) {
                if (a.race.start_time < b.race.start_time) return -1;
                if (a.race.start_time > b.race.start_time) return 1;
                return 0;
            }
            return this.selections.sort(compare);
        },
    },

    setup(props, { emit }) {
        showPlaceBetModal;
        const store = useStore();

        const showPlaceBetModal = ref(false);

        const error = ref({
            message: null,
            cta: false,
        });

        const formatter = new Intl.NumberFormat("en-GB", {
            style: "currency",
            currency: "GBP",
        });

        const leaderboard = ref();

        const message = ref(null);

        const results = ref({});

        const selections = ref({});

        const processing = ref(false);

        const selectionsVisible = ref(false);

        const leaderboardVisible = ref(true);

        const selectedBooster = ref({
            booster: 0,
            runner: 0,
        });

        const confirmSelections = () => {
            showPlaceBetModal.value = true;
        };

        const log = (logger) => {
            return console.log(logger);
        };

        const getResults = () => {
            axios
                .get(route("api.results.index"), {
                    params: {
                        meeting_id: props.meeting.id,
                    },
                })
                .then((response) => {
                    results.value = response.data;

                    let selectedRunners = [];

                    Object.keys(store.state.play.selectedRunners).forEach(
                        (key) => {
                            if (
                                store.state.play.selectedRunners[key].race
                                    .meeting_id == props.meeting.id
                            ) {
                                selectedRunners.push(
                                    store.state.play.selectedRunners[key]
                                );
                            }
                        }
                    );
                    if (selectedRunners.length > 0) {
                        selectionsVisible.value = true;
                        leaderboardVisible.value = false;
                    } else {
                        selectionsVisible.value = false;
                        leaderboardVisible.value = true;
                    }
                });
        };

        const getLeaderboard = () => {
            axios
                .get(route("api.leaderboard.index"), {
                    params: {
                        meeting_id: props.meeting.id,
                    },
                })
                .then((response) => {
                    leaderboard.value = response.data;
                });
        };

        const changeBooster = (booster) => {
            selectedBooster.value = booster;
        }

        const changeSelection = (selection) => {
            emit("changeSelection", selection);
        };

        const clearBooster = () => {
            selectedBooster.value = {
                booster: 0,
                runner: 0,
            };
        };

        const placeBet = () => {
            processing.value = true;

            axios
                .post(route("api.bets.store"), {
                    meeting_id: props.meeting.id,
                    runners: props.selections,
                    price: props.meeting.jackpot.price,
                    currency: props.meeting.jackpot.currency,
                })
                .then((response) => {
                    processing.value = false;

                    store.commit("removeSelectedRunners", props.meeting);

                    emit("betPlaced", response.data);

                    getResults();

                    message.value = "Bet Successfully Placed";

                    setTimeout(() => {
                        message.value = null;
                    }, 3000);

                    console.log(props.meeting.id);
                    console.log(selectedBooster.value.booster.tag);
                    console.log(selectedBooster.value.runner);

                    // Apply boost to bet after bet record processed.
                    return axios
                        .post(route("api.bet.applyBoost"), {
                            meeting_id: props.meeting.id,
                            boost_type: selectedBooster.value.booster.tag,
                            runner: selectedBooster.value.runner,
                        })
                }).then((response) => {
                    clearBooster();

                    store.dispatch("resetPlayState");
                })
                .catch((errors) => {
                    console.log(errors);

                    processing.value = false;
                    if (errors.response.data.tokens != undefined) {
                        error.value.message = errors.response.data.tokens;
                        error.value.cta = true;
                    }

                    if (errors.response.data.bet != undefined) {
                        error.value.message = errors.response.data.bet;
                        error.value.cta = false;

                        getResults();

                        emit("hasBet");
                    }

                    if (errors.response.data.invalid_selections != undefined) {
                        error.value.message =
                            errors.response.data.invalid_selections;

                        errors.response.data.runners.forEach((runner) => {
                            store.commit("removeRunner", runner.race_id);
                        });
                    }
                });
        };

        const clearSelections = () => {
            props.selections.forEach((selection) => {
                store.commit("removeRunner", selection.race_id);
            });
        };

        const showSelections = (selection) => {
            selectionsVisible.value = true;
            leaderboardVisible.value = false;
        };

        const showLeaderboard = (selection) => {
            leaderboardVisible.value = true;
            selectionsVisible.value = false;
        };

        onMounted(() => {
            getResults();
            getLeaderboard();
        });

        const hasBet = computed(() => {
            let hasBet = false;

            props.meeting.bets.forEach((bet) => {
                props.bets.forEach((userBet) => {
                    if (userBet.id === bet.id) {
                        hasBet = true;
                    }
                });
            });

            return hasBet;
        });

        return {
            error,
            changeSelection,
            selectedBooster,
            clearBooster,
            placeBet,
            results,
            hasBet,
            clearSelections,
            processing,
            message,
            hasBet,
            selectionsVisible,
            leaderboardVisible,
            showSelections,
            showLeaderboard,
            leaderboard,
            showPlaceBetModal,
            formatter,
            confirmSelections,
            changeBooster,
        };
    },

    components: {
        XIcon,
        CheckIcon,
        TwModal,
        DatabaseIcon,
        Popper,
        LightningBoltIcon,
        XCircleIcon,
        Selection,
    },
};
</script>
